import { useSnackbar } from "@powerdiary/components-library/lib";
import axios from "axios";
import { useState } from "react";
import { useClientPortalConfigContext } from "../../../context";
import { useAnalytics } from "hooks/useAnalytics";
import { downloadBlob } from "common.ui/Helpers/downloadBlob";

export interface IUseDownloadFormHook {
    downloadForm: () => Promise<void>;
    isDownloading: boolean;
}

export const useDownloadForm = (formNumber: number, formName?: string | null): IUseDownloadFormHook => {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { enqueueSnackbar } = useSnackbar();
    const { track } = useAnalytics();
    const [isDownloading, setIsDownloading] = useState(false);

    const downloadForm = async () => {
        setIsDownloading(true);
        try {
            const response = await axios.get<Blob>(
                `/api/v1/${clientPortalGuid}/CustomForm/DownloadPdf?formDataNumber=${formNumber}`,
                { responseType: "blob" }
            );
            downloadBlob(response.data, `CustomForm_${formNumber}.pdf`);

            track("form_downloaded", { form_id: formNumber, form_name: formName });
        } catch {
            enqueueSnackbar("An error occurred while downloading the form", {
                variant: "error",
            });
        } finally {
            setIsDownloading(false);
        }
    };

    return { downloadForm, isDownloading };
};
